import { v4 as uuidv4 } from 'uuid';

export const HTML_CTA_SELECTOR = '[data-block-type="button"]';

const parse = html => {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    return template;
};

const readCta = (root, element, index) => {
    const scripts = Array.from(root.querySelectorAll('script[type="application/json"]'));
    const script = element.id ? scripts.find(node => node.id === `${element.id}-data`) : null;
    let data = {};
    let error = null;
    if (script) {
        try {
            data = JSON.parse(script.textContent);
            if (!data || Array.isArray(data) || typeof data !== 'object') throw new Error();
        } catch {
            error = 'Il JSON associato alla CTA non è valido. Correggilo nel codice HTML.';
        }
    }
    if (element.id && Array.from(root.querySelectorAll('[id]')).filter(node => node.id === element.id).length > 1) {
        error = 'Questo ID è duplicato. Assegna ID diversi alle CTA nel codice HTML.';
    }
    return {
        index, element, script, data, error,
        label: element.textContent.trim() || element.getAttribute('aria-label') || element.id || `CTA ${index + 1}`,
        attributes: Object.fromEntries(Array.from(element.attributes, attr => [attr.name, attr.value])),
        action: data?.on_click || element.getAttribute('data-button-type') || 'navigate_to',
        url: data?.url ?? element.getAttribute('data-url') ?? element.getAttribute('href') ?? '',
    };
};

export const getHtmlCtas = html => {
    const { content } = parse(html);
    return Array.from(content.querySelectorAll(HTML_CTA_SELECTOR), (element, index) => readCta(content, element, index));
};

// Work on an inert fragment, never on the live preview DOM or its editor decorations.
export const updateHtmlCta = (html, index, change) => {
    const template = parse(html);
    const root = template.content;
    const element = root.querySelectorAll(HTML_CTA_SELECTOR)[index];
    if (!element) return html;
    const cta = readCta(root, element, index);
    if (cta.error) throw new Error(cta.error);
    const data = { ...cta.data };
    let updateData = false;
    if (change.action !== undefined) {
        element.setAttribute('data-button-type', change.action);
        data.on_click = change.action;
        if (change.action === 'navigate_back') data.url = '-1';
        else if (change.action === 'navigate_to') data.url = cta.action === 'navigate_back' ? '' : cta.url;
        if (element.hasAttribute('href')) element.setAttribute('href', change.action === 'navigate_to' ? data.url : '#');
        updateData = true;
    }
    if (change.url !== undefined) {
        data.on_click = cta.action;
        data.url = change.url;
        element.setAttribute('data-button-type', cta.action);
        if (element.hasAttribute('href')) element.setAttribute('href', change.url);
        if (element.hasAttribute('data-url')) element.setAttribute('data-url', change.url);
        updateData = true;
    }
    if (change.attribute) {
        const { name, value } = change.attribute;
        if (!/^(data-[a-z0-9_.:-]+|aria-[a-z0-9_.:-]+|title|target|rel)$/.test(name)
            || ['data-block-type', 'data-button-type', 'data-url'].includes(name)) {
            throw new Error('Usa un attributo data-*, aria-*, title, target o rel.');
        }
        if (value === null) element.removeAttribute(name);
        else element.setAttribute(name, value);
        if (name === 'aria-label' && cta.script) {
            if (value === null) delete data.ariaLabel;
            else data.ariaLabel = value;
            updateData = true;
        }
    }
    if (updateData) {
        if (!element.id) element.id = `html-cta-${uuidv4()}`;
        let script = cta.script;
        if (!script) {
            script = document.createElement('script');
            script.type = 'application/json';
            script.id = `${element.id}-data`;
            element.after(script);
        }
        script.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
    }
    return template.innerHTML;
};
